import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Thumbnail1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V18C1.5 17.1716 2.17157 16.5 3 16.5H6C6.82843 16.5 7.5 17.1716 7.5 18V21C7.5 21.8284 6.82843 22.5 6 22.5ZM3 18V21H6V18H3ZM13.5 22.5H10.5C9.67157 22.5 9 21.8284 9 21V18C9 17.1716 9.67157 16.5 10.5 16.5H13.5C14.3284 16.5 15 17.1716 15 18V21C15 21.8284 14.3284 22.5 13.5 22.5ZM10.5 18V21H13.5V18H10.5ZM21 22.5H18C17.1716 22.5 16.5 21.8284 16.5 21V18C16.5 17.1716 17.1716 16.5 18 16.5H21C21.8284 16.5 22.5 17.1716 22.5 18V21C22.5 21.8284 21.8284 22.5 21 22.5ZM18 18V21H21V18H18ZM21 15H3C2.17157 15 1.5 14.3284 1.5 13.5V3C1.5 2.17157 2.17157 1.5 3 1.5H21C21.8284 1.5 22.5 2.17157 22.5 3V13.5C22.5 14.3284 21.8284 15 21 15ZM3 3V13.5H21V3H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Thumbnail1.vue"]]);
